export const styles = (theme) => ({
  h3: {
    fontSize: "1.25rem",
  },
  body1: {
    display: "inline-block",
  },
  displayFlex: {
    display: "flex",
  },
  flex1: {
    flex: 1,
  },
  marginText: {
    marginLeft: theme.spacing(2),
  },
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
  },
  title: {
    fontWeight: "500",
    lineHeight: "1.334",
    letterSpacing: "-0.05px",
  },
  breakLine: {
    marginLeft: -1 * theme.spacing(3),
    marginRight: -1 * theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  containerContent: {
    padding: theme.spacing(2),
    border: "1px dashed rgba(0, 0, 0, 0.12)",
  },
  wrapContent: {
    padding: theme.spacing(6),
    justifyContent: "center",
    alignItems: "center",
  },
  hoverContent: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.5,
    },
  },
  iconUpload: {
    width: "130px",
  },
  imageUpload: {
    width: "320px",
    height: "180px",
    objectFit: "cover",
  },
  inputImage: {
    display: "none",
  },
  formGroupRoot: {
    alignItems: "flex-start",
  },
  rootLabel: {
    marginRight: theme.spacing(2),
  },
});
